import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  getDataAffectedApptSuccess: (data) => ({ data }),

  resetData: () => ({}),
  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().queueClosure.paging;
      let { result, status } = await Api.post(`queue-closures/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        ...sortOption,
      });
      status === 200 && queueClosureDispatcher.getDataSuccess(result);
    },

  getAffectedAppt:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().queueClosure.pagingAffectedAppt;
      let { result, status } = await Api.post(
        `queue-closures/filter-affected-appts`,
        {
          pageIndex: pagingData.pageIndex,
          pageSize: pagingData.pageSize,
          search,
          ...filterOption,
          ...sortOption,
        }
      );
      status === 200 &&
        queueClosureDispatcher.getDataAffectedApptSuccess(result);
    },
  createQueueClosure:
    (payload, onSuccess, onError) =>
    async ({ Api }) => {
      let { status } = await Api.post(`queue-closures`, payload);
      status === 200 && onSuccess();
      status !== 200 && onError();
    },
  editQueueClosure:
    (id, payload, onSuccess, onError) =>
    async ({ Api }) => {
      let { status } = await Api.put(`queue-closures/${id}`, payload);
      status === 200 && onSuccess();
      status !== 200 && onError();
    },
  stopQueueClosure:
    (id, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.delete(`queue-closures/${id}`);
      status === 200 && onSuccess();
    },
};

const queueClosureDispatcher = synthesize('queueClosure', mapDispatchToAC);
export default queueClosureDispatcher;
